import { PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';

import { NotificationItemRow } from './NotificationItemRow';
import { NotificationRowError } from './NotificationRowError';
import { NotificationRowSkeleton } from './NotificationRowSkeleton';
import useLead from '~/features/leadDetails/hooks/useLead';
import { useConsorsNotesByLead } from '~/features/notifications/hooks/useConsorsNotesByLead';
import { getNotificationLinkOptions } from '~/features/notifications/utils/getNotificationLinkOptions';

type Props = {
    loanRequestId: string;
    subscriptionIdentifier: string;
    processedAt: number;
    onNavigate?: () => void;
};

export const ProcessedBankReportRow: React.FC<Props> = ({
    loanRequestId,
    onNavigate,
    processedAt,
    subscriptionIdentifier,
}) => {
    const lead = useLead(loanRequestId);
    const notes = useConsorsNotesByLead(loanRequestId, subscriptionIdentifier);

    if (lead.isLoading || notes.isLoading) return <NotificationRowSkeleton />;
    if (lead.isError || notes.isError) return <NotificationRowError />;
    if (!lead.data?.antragsteller1) return null;

    const notesList = notes.data?.notes ?? [];
    const firstNote = notesList[0];
    if (!firstNote) return null;

    return (
        <NotificationItemRow
            previewName={`${lead.data.antragsteller1.personendaten?.vorname ?? ''} ${
                lead.data.antragsteller1.personendaten?.nachname ?? ''
            }`.trim()}
            previewDetail={firstNote.data.content}
            tooltipItems={notesList.map((note) => ({ content: note.data.content, id: note.data.id }))}
            timestamp={processedAt}
            link={getNotificationLinkOptions(PROCESSED_NOTIFICATION_KINDS.BANK_REPORT, loanRequestId)}
            onNavigate={onNavigate}
        />
    );
};
